import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Building2, FolderOpen, Users, Activity, AlertCircle, TrendingUp } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import { useNavigate } from 'react-router-dom';
const builderData = [{
  name: 'Active',
  count: 24
}, {
  name: 'Trial',
  count: 8
}, {
  name: 'Inactive',
  count: 3
}];
const activityData = [{
  date: 'Mon',
  sessions: 340
}, {
  date: 'Tue',
  sessions: 298
}, {
  date: 'Wed',
  sessions: 420
}, {
  date: 'Thu',
  sessions: 380
}, {
  date: 'Fri',
  sessions: 290
}, {
  date: 'Sat',
  sessions: 180
}, {
  date: 'Sun',
  sessions: 210
}];
export function AdminDashboardPage() {
  const navigate = useNavigate();
  return <div className="space-y-8 max-w-7xl mx-auto" data-id="element-1177">
      <div className="flex items-center justify-between" data-id="element-1178">
        <div data-id="element-1179">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1180">
            ResVR Admin Dashboard
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-1181">
            Platform overview and system health
          </p>
        </div>
        <div className="flex gap-3" data-id="element-1182">
          <Button variant="outline" onClick={() => navigate('/admin/builders')} data-id="element-1183">
            Manage Builders
          </Button>
          <Button onClick={() => navigate('/admin/projects')} data-id="element-1184">
            View All Projects
          </Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-1185">
        <Card data-id="element-1186">
          <CardContent className="flex items-center p-6" data-id="element-1187">
            <div className="p-3 bg-primary-50 rounded-lg" data-id="element-1188">
              <Building2 className="h-6 w-6 text-primary-600" data-id="element-1189" />
            </div>
            <div className="ml-4" data-id="element-1190">
              <p className="text-sm font-medium text-slate-500" data-id="element-1191">
                Active Builders
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-1192">24</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-1193">
                <span className="font-medium" data-id="element-1194">+3</span>
                <span className="ml-1 text-slate-400" data-id="element-1195">this month</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-1196">
          <CardContent className="flex items-center p-6" data-id="element-1197">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-1198">
              <FolderOpen className="h-6 w-6 text-slate-600" data-id="element-1199" />
            </div>
            <div className="ml-4" data-id="element-1200">
              <p className="text-sm font-medium text-slate-500" data-id="element-1201">
                Total Projects
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-1202">156</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-1203">
                <span className="font-medium" data-id="element-1204">+12</span>
                <span className="ml-1 text-slate-400" data-id="element-1205">this month</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-1206">
          <CardContent className="flex items-center p-6" data-id="element-1207">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-1208">
              <Users className="h-6 w-6 text-slate-600" data-id="element-1209" />
            </div>
            <div className="ml-4" data-id="element-1210">
              <p className="text-sm font-medium text-slate-500" data-id="element-1211">Total Buyers</p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-1212">3,247</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-1213">
                <span className="font-medium" data-id="element-1214">+18%</span>
                <span className="ml-1 text-slate-400" data-id="element-1215">vs last month</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-1216">
          <CardContent className="flex items-center p-6" data-id="element-1217">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-1218">
              <Activity className="h-6 w-6 text-slate-600" data-id="element-1219" />
            </div>
            <div className="ml-4" data-id="element-1220">
              <p className="text-sm font-medium text-slate-500" data-id="element-1221">
                Platform Health
              </p>
              <h3 className="text-lg font-bold text-green-600" data-id="element-1222">Healthy</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-1223">99.8% uptime</p>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1224">
        {/* Activity Chart */}
        <Card className="lg:col-span-2" data-id="element-1225">
          <CardHeader data-id="element-1226">
            <CardTitle data-id="element-1227">Platform Activity (Last 7 Days)</CardTitle>
          </CardHeader>
          <CardContent data-id="element-1228">
            <div className="h-[300px] w-full" data-id="element-1229">
              <ResponsiveContainer width="100%" height="100%" data-id="element-1230">
                <LineChart data={activityData} data-id="element-1231">
                  <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-1232" />
                  <XAxis dataKey="date" tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} data-id="element-1233" />
                  <YAxis tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} data-id="element-1234" />
                  <Tooltip contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                }} data-id="element-1235" />
                  <Line type="monotone" dataKey="sessions" stroke="#06b6d4" strokeWidth={2} dot={{
                  fill: '#06b6d4'
                }} data-id="element-1236" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>

        {/* Builder Status */}
        <Card data-id="element-1237">
          <CardHeader data-id="element-1238">
            <CardTitle data-id="element-1239">Builder Status</CardTitle>
          </CardHeader>
          <CardContent data-id="element-1240">
            <div className="space-y-4" data-id="element-1241">
              {builderData.map(item => <div key={item.name} className="flex items-center justify-between" data-id="element-1242">
                  <span className="text-sm font-medium text-slate-700" data-id="element-1243">
                    {item.name}
                  </span>
                  <div className="flex items-center gap-2" data-id="element-1244">
                    <span className="text-2xl font-bold text-slate-900" data-id="element-1245">
                      {item.count}
                    </span>
                    <Badge variant={item.name === 'Active' ? 'success' : item.name === 'Trial' ? 'warning' : 'neutral'} data-id="element-1246">
                      {item.name}
                    </Badge>
                  </div>
                </div>)}
            </div>
            <div className="mt-6 pt-6 border-t border-slate-100" data-id="element-1247">
              <Button variant="outline" className="w-full" onClick={() => navigate('/admin/builders')} data-id="element-1248">
                View All Builders
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Recent Activity */}
      <Card data-id="element-1249">
        <CardHeader data-id="element-1250">
          <CardTitle data-id="element-1251">Recent Builder Activity</CardTitle>
        </CardHeader>
        <CardContent data-id="element-1252">
          <div className="space-y-4" data-id="element-1253">
            <div className="flex items-start gap-4 pb-4 border-b border-slate-100" data-id="element-1254">
              <div className="p-2 bg-green-50 rounded-lg" data-id="element-1255">
                <TrendingUp className="h-4 w-4 text-green-600" data-id="element-1256" />
              </div>
              <div className="flex-1" data-id="element-1257">
                <p className="text-sm font-medium text-slate-900" data-id="element-1258">
                  Acme Homes activated new project
                </p>
                <p className="text-xs text-slate-500 mt-1" data-id="element-1259">
                  The Riverside Collection - 2 hours ago
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4 pb-4 border-b border-slate-100" data-id="element-1260">
              <div className="p-2 bg-blue-50 rounded-lg" data-id="element-1261">
                <Building2 className="h-4 w-4 text-blue-600" data-id="element-1262" />
              </div>
              <div className="flex-1" data-id="element-1263">
                <p className="text-sm font-medium text-slate-900" data-id="element-1264">
                  New builder onboarded
                </p>
                <p className="text-xs text-slate-500 mt-1" data-id="element-1265">
                  Summit Builders LLC - 5 hours ago
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-1266">
              <div className="p-2 bg-amber-50 rounded-lg" data-id="element-1267">
                <AlertCircle className="h-4 w-4 text-amber-600" data-id="element-1268" />
              </div>
              <div className="flex-1" data-id="element-1269">
                <p className="text-sm font-medium text-slate-900" data-id="element-1270">
                  Support request submitted
                </p>
                <p className="text-xs text-slate-500 mt-1" data-id="element-1271">
                  Horizon Developments - Options sync issue - 1 day ago
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}